import Modal from "components/common/Modal/Modal";
import classes from "./ManageAccountLayout.module.css";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { Heading } from "components/common";
import clsx from "clsx";
import { devider } from "images";
import Profile from "pages/ManageAccount/Profile/Profile";
import Security from "pages/ManageAccount/Security/Security";
import Subscription from "pages/ManageAccount/Subscription/Subscription";
import ChatData from "pages/ManageAccount/ChatData/ChatData";

const navItems = ["Subscription", "Chat Data", "Profile"];

const ManageAccountLayout = ({ isActive, onClose, isLoggedIn, userData }) => {
  const [activeNavItem, setActiveNavItem] = useState("Subscription");

  return (
    <Modal
      className={classes.modal}
      isActive={isActive}
      onClose={onClose}
      noHeading
    >
      <div className={classes.header}>
        <Heading primitive50 medium lg>
          Manage Account
        </Heading>
        <button className={classes.closeButton} onClick={onClose}>
          <IoClose className={classes.closeIcon} />
        </button>
      </div>
      
      <div className={classes.navItems}>
        {navItems.map((navItem, id) => (
          <button
            key={"manage-account-nav-item-" + id}
            onClick={() => setActiveNavItem(navItem)}
            className={clsx(
              classes.navItem,
              activeNavItem === navItem && classes.active
            )}
          >
            {navItem}
          </button>
        ))}
      </div>
      <img src={devider} alt="#" className={classes.devider} />
      
      <div className={classes.content}>
        {activeNavItem === "Profile" && <Profile userData={userData} />}
        {activeNavItem === "Security" && <Security />}
        {activeNavItem === "Subscription" && <Subscription userData={userData} />}
        {activeNavItem === "Chat Data" && <ChatData onClose={onClose} />}
      </div>
    </Modal>
  );
};

export default ManageAccountLayout;
